import * as React from "react";
function SvgFacebookReactionSad(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill="#fddb74" />
      <path
        d="M38.24 34.77c-.46 0-3.65 6.85-3.65 8.8a3.65 3.65 0 007.3 0c0-1.95-3.19-8.8-3.65-8.8z"
        fill="#6586c2"
      />
      <path
        d="M24 33.82a8.39 8.39 0 00-6.41 2.92 1.09 1.09 0 101.66 1.42 6.31 6.31 0 019.49 0 1.09 1.09 0 101.66-1.42 8.39 8.39 0 00-6.4-2.92zM13.57 23.39a3.21 3.21 0 000 6.41 3.21 3.21 0 000-6.41zm2.12-3.25a1 1 0 00-.92-1A8.88 8.88 0 007.55 23a1 1 0 101.69.89A7 7 0 0114.71 21a1 1 0 00.98-.86zm18.75 3.25a3.21 3.21 0 103 3.41v-.2a3.11 3.11 0 00-3-3.21zm6-.38a8.89 8.89 0 00-7.22-3.85 1 1 0 00-.92 1 .94.94 0 001 .92 7 7 0 015.47 2.84 1 1 0 101.68-.92z"
        fill="#282c39"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionSad);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
